export default __webpack_public_path__ + "static/media/st1.751e6265.jpg";